module.exports = __webpack_public_path__ + "static/media/correct.50ed6d61.svg";